<template>
  <div class="group-setup" v-if="canApprove() && uuid">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">CPE Project Review ({{ stringFormatting(role) }})</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-row>
        <v-col cols="12" v-if="canApprove() && uuid">
          <ApprovalFrom :uuid="uuid" :data="data" @updateApproval="updateApproval()"></ApprovalFrom>
        </v-col>
      </v-row>

      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import ApprovalFrom from "../approval/ApprovalFrom";

export default {
  name: "groupSetUpFrom",
  props: ["data", 'uuid'],
  components: { ApprovalFrom },

  data: () => ({
    role: localStorage.getItem('role') || null
  }),

  mounted() { },

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    canApprove() {

      if (this.data.status === 'SUBMITTED' && (this.role === 'CLUBS_PERFORMANCE_EVALUATION'
        || this.role === 'REGION_CPE_COORDINATOR'
      )) {
        return true;
      } else if (this.data.status === 'REGION_REVIEWED' && this.role === 'CLUBS_PERFORMANCE_EVALUATION') {
        return true;
      } else {
        return false;
      }

    }
  },
};
</script>
